var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrillElectrictoolsInstallations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49502 13H8.74687V15C8.74687 15.1989 8.66782 15.3897 8.52712 15.5303C8.38642 15.671 8.19558 15.75 7.9966 15.75H1.7444C1.54542 15.75 1.35459 15.671 1.21389 15.5303C1.07319 15.3897 0.994141 15.1989 0.994141 15V13H1.7444",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7483 3.2503C11.236 3.16655 11.6999 2.92343 11.8593 2.3978L11.7724 1.9053L11.6918 1.43093C11.3635 0.98968 10.737 0.91593 10.25 1.0003",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.748 1.75L15.7491 1.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7479 13.0002V12.6065C8.74741 12.4352 8.68827 12.2692 8.58032 12.1362C8.47238 12.0031 8.32213 11.911 8.15457 11.8752L5.24667 11.2502C4.57706 10.3677 5.97317 9.24021 5.24667 7.25021L5.74684 6.75021V5.25021L7.49746 5.00021C8.22834 4.87521 9.63259 4.02521 9.63259 4.02521L9.03925 0.392706C9.03925 0.392706 7.48996 0.161456 6.75845 0.287706L0.65693 1.31271C0.526528 1.34019 0.411955 1.41735 0.337493 1.52783C0.263031 1.63832 0.234534 1.77345 0.25804 1.90458L0.851999 5.28708L1.99553 6.50021C1.49535 8.75021 1.99553 11.2502 1.99553 11.2502L1.40969 11.5427C1.28505 11.6051 1.18024 11.7009 1.10702 11.8195C1.0338 11.938 0.995074 12.0746 0.995174 12.214V13.0002",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74609 6.74957H7.99653C7.99653 6.74957 7.38382 5.4877 8.13783 4.79395",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.453125 3.02125L1.99429 2.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.671875 4.26875L2.2443 4",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillElectrictoolsInstallations);
export default __webpack_public_path__ + "static/media/drill-electric tools-installations.37637e1e.svg";
export { ForwardRef as ReactComponent };